export default {"src":"/_next/static/media/hamburger.599142e5.svg","height":14,"width":20};